module.exports = __webpack_public_path__ + "img/id-3.356177e3.png";